export default {
  setState: 'Set equipment state',
  stop: 'Stop: {eventType}',
  start: 'Start: {eventType}',
};
